export { default } from './CallToAction';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Hero/CallToAction/index.js